// extracted by mini-css-extract-plugin
export var container = "_jc-0";